<div class="card" *blockUI="'section-block'">
    <div class="row">
        <div class="col-12 mb-50">

        </div>
        <div class="col-md-6 col-12">
            <div class="d-flex justify-content-between align-items-center m-1">
                <label class="d-flex align-items-center">
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption"
                        (ngModelChange)="onOptionChange()">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="50">50</option>
                    </select>
                    
                </label>
            </div>
        </div>
        <div class="col-md-6 col-12 d-flex justify-content-md-end">
            <div class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0">
                <label class="d-flex align-items-center">Bul<input type="search" placeholder="Bul"
                        class="form-control ml-25" (keyup)="filterUpdate($event)"
                        (search)="filterUpdate($event)" /></label>
            </div>
        </div>
    </div>
    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
        emptyMessage: 'Veri Yok',
        totalMessage: 'Toplam', 
        selectedMessage: 'Seçili'
      }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [scrollbarH]="true" (activate)="onActivate($event)">
        <ng-template ngx-datatable-cell-template let-row="row">
            <a href="#/admin/order-detail/{{row.id}}">{{row.name}}</a>
        </ng-template>

        <ngx-datatable-column name="Sipariş No" prop="no" [width]="50"></ngx-datatable-column>
        <ngx-datatable-column name="Firma Adı" prop="companyName" class="ellipsis-column" width="200">
        </ngx-datatable-column>
        <ngx-datatable-column name="Bitiş Tarihi" [width]="60">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.validtiyDate | date: 'dd.MM.yyyy HH:mm'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Durumu" [width]="60">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div [ngClass]="getStatusClass(row.status)">
                    {{ getStatusText(row.status) }}
                </div>
            </ng-template>
        </ngx-datatable-column>



        <!-- <ngx-datatable-column [width]="40" [sortable]="false">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <div ngbDropdown container="body">
                    <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                      <span [data-feather]="'more-vertical'" [class]="'cursor-pointer'"></span>
                    </button>
                    <div ngbDropdownMenu>
                      <a href="#/admin/company/{{row.id}}" ngbDropdownItem
                        class="d-flex align-items-center"><i data-feather="file-text" class="mr-50"></i>Görüntüle</a>
                       <a href="javascript:;" ngbDropdownItem
                          ><span [data-feather]="'trash'" [size]="16" [class]="'mr-50'"></span> Delete</a
                        > 
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column> -->
        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>


                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)" [maxSize]="5">
                        <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                                [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                                [class]="'font-weight-bolder'"></span></ng-template>
                    </ngb-pagination>
                </div>

            </ng-template>

        </ngx-datatable-footer>
    </ngx-datatable>
</div>